module.exports = __webpack_public_path__ + "img/blackRose.032b33b7.jpg";